var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("pages-wrapper", [
    _c(
      "div",
      { staticClass: "club-page" },
      [
        _c("h1", { staticClass: "club-title" }, [
          _vm._v("\n      " + _vm._s(_vm.pageTitle) + "\n    ")
        ]),
        _c("banners-slot", {
          staticClass: "club-welcome-banner",
          attrs: { "with-category": false, "slot-name": "banner_info_club1" }
        }),
        _c("fragment", {
          staticClass: "club-advantages",
          attrs: { prefetch: "", "slot-name": "club_info_advantages" }
        }),
        _c("banners-slot", {
          staticClass: "club-middle-banner",
          attrs: { "with-category": false, "slot-name": "banner_info_club2" }
        }),
        _c("fragment", {
          attrs: { prefetch: "", "slot-name": "club_info_guide" }
        }),
        _c("banners-slot", {
          staticClass: "club-footer-banner",
          attrs: { "with-category": false, "slot-name": "banner_info_club3" }
        }),
        _c("h2", [_vm._v("Вопросы и ответы")]),
        _c("ui-accordion", {
          staticClass: "club-questions",
          attrs: { items: _vm.clubQuestions }
        })
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }